export var AUM_DATA = "AUM_DATA";
